module.exports = __webpack_public_path__ + "media/images/logo-gocanvas-drop-transparent-d82036bd.svg";